import * as event from '@/utils/Event'
import * as image from '@/utils/Image'
import * as string from '@/utils/String'
import * as token from '@/utils/Token'

export default {
  install (Vue, options) {
    Vue.prototype.$utils = {}
    Vue.prototype.$utils.event = event
    Vue.prototype.$utils.image = image
    Vue.prototype.$utils.string = string
    Vue.prototype.$utils.token = token
    Vue.utils = {}
    Vue.utils.event = event
    Vue.utils.image = image
    Vue.utils.string = string
    Vue.utils.token = token
  },
}
